module.exports = __webpack_public_path__ + "static/media/Южный Лес день.55d40509.jpg";